<template>
  <div class="password-complete">

    <reissue-password-form
      action="./"
      reissue-key=""
      ref="reissue"
    ></reissue-password-form>

    <base-modal :href="href">
      <p class="password-complete__text">設定しました。</p>
    </base-modal>

  </div>
</template>

<script>
import ReissuePasswordForm from './ReissuePasswordForm'
import BaseModal from '../common/BaseModal'

export default {
  name: 'UserAccountPasswordComplete',
  components: {
    BaseModal,
    ReissuePasswordForm
  },
  props: {
    href: {
      type: String,
      default: ''
    },
  },
  created () {
    // ログアウト処理
    this.$store.dispatch('LOGOUT')
  },
  mounted () {
    // それっぽく見せる為に設定
    this.$refs.reissue.$data.password = '●●●●●●●●'
    this.$refs.reissue.$data.re_password = '●●●●●●●●'
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../sass/commons/commonVariables.scss';

.password-complete {
  color: $col_base_black;
  line-height: 1.6;
  &__text {
    margin: 0 0 60px;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/User/UserAccountPasswordComplete.vue